import fetcher from "@/core/lib/fetcher";
import { APIResponse } from "@/core/types/utils";
import { queryOptions } from "@tanstack/react-query";
import { Metrics } from "./metrics.types";

export const metricsQueryOptions = (
	token: string,
	propertyId: string,
	startDate: string,
	endDate: string,
) =>
	queryOptions({
		queryKey: ["metrics", propertyId, startDate, endDate, token],
		queryFn: () =>
			fetcher
				.auth(`Bearer ${token}`)
				.get(
					import.meta.env.VITE_API_BOOKING +
						`property/${propertyId}/bookings/metrics?startDate=${startDate}&endDate=${endDate}&origin=Web`,
				)
				.notFound(() => {
					return {
						data: {
							analytics: {
								totalPurchase: 0,
								totalSession: 0,
								totalActiveUser: 0,
								conversionRate: 0,
								totalsByDevice: {
									desktop: { activeUsers: 0, sessions: 0, transactions: 0 },
									mobile: { activeUsers: 0, sessions: 0, transactions: 0 },
									tablet: { activeUsers: 0, sessions: 0, transactions: 0 },
								},
								dates: [],
							},
							averagePriceAndDistribution: {
								totalBooking: 0,
								averageBookingPrice: 0,
								distribution: [],
							},
							bookingsByCountry: [],
							bookingsGroupByType: {
								currentTotals: {
									totalBookings: 0,
									rates: 0,
									activities: 0,
									packages: 0,
									activitiesRevenue: 0,
									ratesRevenue: 0,
									packagesRevenue: 0,
									totalRevenue: 0,
								},
								trendPercentages: {
									totalBookings: 0,
									activities: 0,
									packages: 0,
									rates: 0,
								},
								data: [],
							},
							cancellationsGroupByType: {
								currentTotals: {
									totalBookings: 0,
									rates: 0,
									activities: 0,
									packages: 0,
									activitiesRevenue: 0,
									ratesRevenue: 0,
									packagesRevenue: 0,
									totalRevenue: 0,
								},
								trendPercentages: {
									totalBookings: 0,
									activities: 0,
									packages: 0,
									rates: 0,
								},
								data: [],
							},
							completedStays: {
								currentTotals: {
									completedBookings: 0,
									revenue: 0,
								},
								trendPercentages: {
									completedBookings: 0,
									revenue: 0,
								},
								data: [],
							},
							occupancyByMonth: {
								currentTotals: {
									occupancyPercentage: 0,
									roomsBooked: 0,
								},
								trendPercentages: {
									occupancyPercentage: 0,
									roomsBooked: 0,
								},
								data: [],
							},
							promoCodes: [],
							roomBlocks: { totalUses: 0, totalRevenue: 0, items: [] },
						} as Metrics,
					};
				})
				.json<Promise<APIResponse<Metrics>>>(),
	});

export const downloadReport = (
	token: string,
	startDate: string,
	endDate: string,
	propertyId: string,
) =>
	fetcher
		.auth(`Bearer ${token}`)
		.get(
			import.meta.env.VITE_API_BOOKING +
				`property/${propertyId}/bookings/metrics/pdf?startDate=${startDate}&endDate=${endDate}`,
		)
		.blob();
